import React from 'react';
import ReactJson from 'react-json-view'

export const getJSONTheme = () => window.openkbsTheme?.palette?.mode === 'dark'
    ? {
        base00: 'rgba(255, 255, 255, 0.00)',
        base01: '#202020',
        base02: '#303030',
        base03: '#505050',
        base04: '#B0B0B0',
        base05: '#D0D0D0',
        base06: '#E0E0E0',
        base07: '#FFFFFF',
        base08: '#DD464C',
        base09: '#ffbc82',
        base0A: '#FDCC59',
        base0B: '#8FC13E',
        base0C: '#149B93',
        base0D: '#fff',
        base0E: '#fff',
        base0F: '#BBBBBB'
    }
    : {
        base00: 'rgba(0, 0, 0, 0.1)',
        base01: '#e0e0e0',
        base02: '#c0c0c0',
        base03: '#a0a0a0',
        base04: '#808080',
        base05: '#606060',
        base06: '#404040',
        base07: '#202020',
        base08: '#d32f2f',
        base09: '#CB4B17',
        base0A: '#fbc02d',
        base0B: '#388e3c',
        base0C: '#0097a7',
        base0D: '#808080',
        base0E: '#7b1fa2',
        base0F: '#5d4037'
    }
export const JSONComponent = ({data, props, enableClipboard = false, collapsed = true}) => {
    if (!data) return null

    return <ReactJson theme={getJSONTheme()}
                      style={{fontSize: 14, width: '80%', borderRadius: '20px', paddingTop: '8px', paddingLeft: '8px'}}
                      src={data}
                      displayDataTypes={false}
                      name={null}
                      enableClipboard={enableClipboard}
                      collapsed={collapsed}
                      // collapseStringsAfterLength={80}
                      {...props} />
};

